import { computed, makeObservable } from 'mobx'

import { ModelWithPolicy } from 'modules/core/lib/modelWithPolicy'

interface IField {
  [key: string]: any
}

class Field extends ModelWithPolicy<IField, string> {
  static IDENTIFIERS = {
    endsOn: 'ends_on', // ... add more as needed
  }

  constructor(attr: IField = {}) {
    super(attr)
    makeObservable(this, {
      isReadonly: computed,
    })
  }

  static urlRoot() {
    return '/custom_resources/fields'
  }

  get isReadonly(): boolean {
    return this.attributes.is_readonly
  }
}

export default Field
